import { render } from "./ImportDetail.vue?vue&type=template&id=39a91727&scoped=true"
import script from "./ImportDetail.vue?vue&type=script&lang=js"
export * from "./ImportDetail.vue?vue&type=script&lang=js"

import "./ImportDetail.vue?vue&type=style&index=0&id=39a91727&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a91727"]])

export default __exports__